<template>
    <Head title="Manage Lokasi"></Head>
    <link rel="stylesheet" href="https://unpkg.com/leaflet-geosearch@2.6.0/assets/css/leaflet.css"/>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <Toast />

                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <div class="my-2">
                            <Button
                                label="New"
                                icon="pi pi-plus"
                                class="p-button-success mr-2"
                                @click="openNew"
                            />
                            <Button
                                label="Delete"
                                icon="pi pi-trash"
                                class="p-button-danger"
                                @click="confirmDeleteSelected"
                                :disabled="
                                    !selectedModels || !selectedModels.length
                                "
                            />
                        </div>
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    :selectAll="selectAll"
                    @select-all-change="onSelectAllChange"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Lokasi</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                        headerStyle="width: 3rem"
                    ></Column>
                    <Column
                        field="code"
                        header="No"
                        :sortable="true"
                        headerStyle="width:5%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Id</span>
                            {{ slotProps.data.id }}
                        </template>
                    </Column>
                    <Column
                        field="location_name"
                        header="Nama Lokasi"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Nama Lokasi</span>
                            {{ slotProps.data.location_name }}
                        </template>
                    </Column>
                    <Column
                        field="office_lat"
                        header="Latitude Kantor"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Latitude Kantor</span>
                            {{ slotProps.data.office_lat }}
                        </template>
                    </Column>
                    <Column
                        field="office_long"
                        header="Longitude Kantor"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Longitude Kantor</span>
                            {{ slotProps.data.office_long }}
                        </template>
                    </Column>
                    <Column
                        field="radius"
                        header="Radius"
                        :sortable="true"
                        headerStyle="width:70%; min-width:10rem;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Radius</span>
                            {{ slotProps.data.radius }}
                        </template>
                    </Column>
                    <Column headerStyle="width:15%;min-width:10rem;">
                        <template #body="slotProps">
                            <Button
                                icon="pi pi-pencil"
                                class="p-button-rounded p-button-success mr-2"
                                @click="editModel(slotProps.data)"
                            />
                            <Button
                                icon="pi pi-trash"
                                class="p-button-rounded p-button-warning mt-2"
                                @click="confirmDeleteModel(slotProps.data)"
                            />
                        </template>
                    </Column>
                </DataTable>

                <Dialog
                    v-model:visible="modelDialog"
                    :style="{ width: '450px' }"
                    :header="'Shift Detail'"
                    :modal="true"
                    class="p-fluid"
                >
                    <div class="field">
                        <label for="location_name">Nama Lokasi</label>
                        <InputText
                            id="location_name"
                            v-model="model.location_name"
                            required="true"
                            :class="{ 'p-invalid': submitted && !model.location_name }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.location_name"
                            >Nama Lokasi is required.</small
                        >
                    </div>
                    <div class="field">
                        <label for="radius">Radius</label>
                        <InputText
                            id="radius"
                            v-model="model.radius"
                            required="true"
                            :class="{ 'p-invalid': submitted && !model.radius }"
                        />
                        <small class="p-invalid" v-if="submitted && !model.radius"
                            >Radius is required.</small
                        >
                    </div>
                    <div class="field">
                        <div style="width: 100%; height: 320px;">
                            <l-map
                                ref="map"
                                v-model="zoom"
                                v-model:zoom="zoom"
                                :center="[-4.3281066, 116.4106543]"
                                @ready="onGeoSearch"
                                @dblclick="onMapClick"
                            >
                                <l-tile-layer
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                ></l-tile-layer>
                                <l-marker
                                    v-if="model.lat && model.lng"
                                    visible
                                    draggable
                                    :lat-lng.sync="{lat: model.lat, lng: model.lng}"
                                    @drag="onDragOver"
                                >
                                    <l-icon :icon-url="iconUrl" />
                                </l-marker>
                                <l-circle
                                    v-if="model.lat && model.lng && model.radius"
                                    :lat-lng="{lat: model.lat, lng: model.lng}"
                                    :radius="+model.radius"
                                    color="red"
                                >
                                </l-circle>
                            </l-map>
                        </div>
                    </div>
                    <template #footer>
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="hideDialog"
                        />
                        <Button
                            label="Save"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="saveModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete
                            <b>{{ model.name }}</b
                            >?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteModel"
                        />
                    </template>
                </Dialog>

                <Dialog
                    v-model:visible="deleteModelsDialog"
                    :style="{ width: '450px' }"
                    header="Confirm"
                    :modal="true"
                >
                    <div class="flex align-items-center justify-content-center">
                        <i
                            class="pi pi-exclamation-triangle mr-3"
                            style="font-size: 2rem"
                        />
                        <span v-if="model"
                            >Are you sure you want to delete the selected
                            models?</span
                        >
                    </div>
                    <template #footer>
                        <Button
                            label="No"
                            icon="pi pi-times"
                            class="p-button-text"
                            @click="deleteModelsDialog = false"
                        />
                        <Button
                            label="Yes"
                            icon="pi pi-check"
                            class="p-button-text"
                            @click="deleteSelectedModels"
                        />
                    </template>
                </Dialog>
            </div>
        </div>
    </div>
</template>


<script>
    import AppLayout from "../../Layouts/AppLayout";
    import { FilterMatchMode } from "primevue/api";
    import { Head } from "@inertiajs/inertia-vue3";
    import Checkbox from "primevue/checkbox";
    import Button from "primevue/button";
    import InputText from "primevue/inputtext";
    import Password from "primevue/password";
    import Message from "primevue/message";
    import Toolbar from "primevue/toolbar";
    import Toast from "primevue/toast";
    import FileUpload from "primevue/fileupload";
    import Calendar from "primevue/calendar";
    import DataTable from "primevue/datatable";
    import Column from "primevue/column";
    import InputNumber from "primevue/inputnumber";
    import Dropdown from "primevue/dropdown";
    import RadioButton from "primevue/radiobutton";
    import Dialog from "primevue/dialog";
    import DatatableService from "../../Services/DatatableService";
    import axios from "axios";
    // maps
    import {
        LMap,
        LTileLayer,
        LControlLayers,
        LMarker,
        LIcon,
        LCircle
    } from '@vue-leaflet/vue-leaflet';
    import "leaflet/dist/leaflet.css";
    import "leaflet-geosearch/assets/css/leaflet.css";
    import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch';

    export default {
        name: 'Index',
        layout: AppLayout,
        components: {
            Head,
            Checkbox,
            Button,
            InputText,
            Password,
            Message,
            Toolbar,
            Toast,
            FileUpload,
            DataTable,
            Column,
            InputNumber,
            Dropdown,
            RadioButton,
            Dialog,
            Calendar,
            LMap,
            LTileLayer,
            LControlLayers,
            LMarker,
            LIcon,
            LCircle,
        },
        data() {
            return {
                searchFilter: "",
                filters: {
                    global: {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    },
                    status: { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                lazyParams: {
                    global: {
                        value: null,
                        matchMode: FilterMatchMode.CONTAINS,
                    },
                    status: { value: null, matchMode: FilterMatchMode.EQUALS },
                },
                totalRecords: 0,
                loading: false,
                model: {
                    location_name: null,
                    radius: null,
                    lat: null,
                    lng: null,
                },
                submitted: false,
                modelDialog: false,
                models: null,
                deleteModelDialog: false,
                deleteModelsDialog: false,
                selectedModels: null,
                submitted: false,
                selectAll: false,
                // Maps
                zoom: 5,
                iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.6.0/images/marker-icon.png',
            }
        },
        datatableService: null,
        created() {
            this.datatableService = new DatatableService();
            this.initFilters();
        },
        mounted() {
            this.lazyParams = {
                first: 0,
                rows: this.$refs.dt.rows,
                sortField: "id",
                sortOrder: -1,
                filters: this.filters,
            },
            this.loadLazyData()
        },
        methods: {
            loadLazyData() {
                this.loading = true
                this.datatableService
                    .getData(this.route('api.location.index'), this.lazyParams)
                    .then(data => {
                        this.models = data.data.data;
                        this.totalRecords = data.data.length;
                    })

                this.loading = false
            },
            onDragOver(value) {
                const { lat, lng } = value.latlng
                this.model.lat = lat
                this.model.lng = lng
            },
            onMapClick(value) {
                const { lat, lng } = value.latlng
                this.model.lat = lat
                this.model.lng = lng
            },
            onSelectAllChange(event) {
                const selectAll = event.checked;
                if (selectAll) {
                    this.datatableService.getData(this.route("api.location.index"),this.lazyParams).then((data) => {
                        this.selectAll = true;
                        this.selectedModels = data[0];
                    });
                } else {
                    this.selectAll = false;
                    this.selectedModels = [];
                }
            },
            onRowSelect() {
                this.selectAll = this.selectedModels.length === this.totalRecord;
            },
            onRowUnselect() {
                this.selectAll = false;
            },
            onPage(event) {
                this.lazyParams = event;
                this.loadLazyData();
            },
            onSort(event) {
                this.lazyParams = event;
                this.loadLazyData();
            },
            onFilter(event) {
                this.loadLazyData();
            },
            openNew() {
                this.model = {};
                this.submitted = false;
                this.modelDialog = true;
            },
            onGeoSearch(){
                const map = this.$refs.map.leafletObject // work as expected
                const provider = new OpenStreetMapProvider()
                const searchControl = new GeoSearchControl({
                    provider,
                    showMarker : false,
                });

                map.addControl(searchControl);
                map.on('geosearch/showlocation', this.addMarker);
            },
            addMarker(event){
                this.model.lat = event.location.y;
                this.model.lng = event.location.x;
            },
            hideDialog() {
                this.modelDialog = false;
                this.submitted = false;
            },
            saveModel() {
                this.submitted = true

                if(this.model){
                    let { location_name, lng, lat, radius } = this.model

                    const data = {
                        location_name,
                        office_lat: lat,
                        office_long: lng,
                        radius
                    }

                    if(this.model.id) {
                        axios
                            .put(this.route('api.location.update', this.model.id), data)
                            .then((response) => {
                                this.$toast.add({
                                    severity: "success",
                                    summary: "Successful",
                                    detail: "Location Updated",
                                    life: 3000,
                                });
                                this.loadLazyData()
                                this.modelDialog = false
                                this.submitted = false
                            })
                            .catch((error) => {
                                this.$toast.add({
                                    severity: "error",
                                    summary: "Error",
                                    detail: "Location not updated",
                                    life: 3000,
                                });
                            });

                        return;
                    }

                    axios.post(this.route('api.location.store'), data)
                    .then((response) => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Location Created",
                            life: 3000,
                        });
                        this.loadLazyData()
                        this.modelDialog = false
                        this.submitted = false
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Location not created",
                            life: 3000,
                        });
                    });
                }
            },
            editModel(model) {
                const { office_lat, office_long, location_name, radius, id } = model

                this.model = {
                    id,
                    lat: office_lat,
                    lng: office_long,
                    location_name,
                    radius
                 };
                this.modelDialog = true;
            },
            deleteModel() {
                axios
                    .delete(this.route('api.location.destroy', this.model.id))
                    .then((response) => {
                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Location Deleted",
                            life: 3000,
                        });
                        this.deleteModelDialog = false;
                        this.model = {};
                        this.loadLazyData();
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Location not deleted",
                            life: 3000,
                        });
                    });
            },
            confirmDeleteModel(model) {
                this.model = model;
                this.deleteModelDialog = true;
            },
            confirmDeleteSelected() {
                this.deleteModelsDialog = true;
            },
            deleteSelectedModels() {
                this.models = this.models.filter(
                    (val) => !this.selectedModels.includes(val)
                );
                this.deleteModelsDialog = false;
                this.selectedModels = null;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Models Deleted",
                    life: 3000,
                });
            },
            initFilters() {
                this.filters = {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                };
            },
        }
    }
</script>

<style></style>
